import { motion } from 'framer-motion';

import Certi1 from '../assets/certi1.jpeg';
import Certi2 from '../assets/certi2.jpeg';
import Certi3 from '../assets/certi3.jpeg';
import Certi4 from '../assets/certi4.jpeg';
import Certi6 from '../assets/certi6.jpeg';
import Certi7 from '../assets/certi7.jpeg';
import Certi8 from '../assets/certi8.jpeg';
import Certi9 from '../assets/certi9.jpeg';
import Certi10 from '../assets/certi10.jpeg';
import Certi11 from '../assets/certi11.jpeg';
import Certi12 from '../assets/certi12.jpeg';
import Certi13 from '../assets/certi13.jpeg';
import Certi14 from '../assets/certi14.jpeg';
import Certi15 from '../assets/certi15.jpeg';
import Certi16 from '../assets/certi16.jpeg';



const certData = [
 { img: Certi4, desc: "Received the Academic Excellence Certificate for securing 2nd rank in 2nd and 3rd semesters at IFET College of Engineering during the Silver Jubilee celebration." },
   { img: Certi10, desc: "Secured 2nd place in the IEEE Idea Presentation on Engineers Day for presenting 'Style Shield' – an innovative solution addressing real-world challenges faced by women." },
  { img: Certi11, desc: "Won 3rd prize in the Engineers Day Poster Presentation under the theme Digital Dreams 2024 for presenting 'Smart City Management Using AI and IoT Sensors." },

  { img: Certi13, desc: "Stepped out of our comfort zones to perform a mime for the first time and won 1st place on Women’s Day — a powerful reminder of teamwork, creativity, and growth through expression!" },
  { img: Certi16, desc: "First Prize – InnovateX, RMK Engineering College,Won first place in an on-spot problem-solving and pitch event, overcoming a late start by quickly adapting and presenting a strong solution under time pressure." },

  { img: Certi15, desc: "Secured 2nd Prize in the Paper Presentation event at the Magnus Symposium, hosted by the AIML Department, Chennai Institute of Technology — a rewarding experience of innovation, collaboration, and impactful ideas! " },
  { img: Certi14, desc: "Secured 1st Prize in the Proto Pitch event during the Magnus Symposium hosted by the AIML Department at Chennai Institute of Technology — an unforgettable journey of rapid innovation, teamwork, and impactful pitching! " },
  
  { img: Certi12, desc: "Completed 50 Very Easy challenges on Skillrack, strengthening problem-solving and coding fundamentals." },
   { img: Certi6, desc: "Successfully completed an internship at LeMeniz Technologies Pvt Ltd, gaining hands-on experience in HTML, CSS, JavaScript, Web Development, and Android App Development." },
  { img: Certi7, desc: "Completed a seminar titled 'A Journey into Technology Excellence' at Askan Technologies, gaining insights into industry trends, innovation, and mobile app solutions." },
 
   { img: Certi1, desc: "Attended Cognebula'24 Symposium at Velammal Engineering College.Learned about using AI tools in product development and startups." },
  { img: Certi2, desc: "Presented a paper on Artificial Intelligence at Thiagarajar College of Engineering, Madurai." },
  { img: Certi3, desc: "Participated in the Tech Escalade aptitude event at Thiagarajar College of Engineering, Madurai. " },
  

   { img: Certi8, desc: "Participated in the Prompt Quest event at St. Joseph's College, exploring AI-driven image recreation and creative innovation." },
  { img: Certi9, desc: "Presented a paper and advanced to Round 2 at Aurora'24 Symposium, Saveetha Engineering College, and participated in the Technical Connection event." },

];

// Animation variants
const cardVariants = {
  hidden: { opacity: 0, y: 40 },
  visible: (i) => ({
    opacity: 1,
    y: 0,
    transition: {
      delay: i * 0.1,
      duration: 0.6,
      ease: "easeOut",
    },
  }),
};

export default function Certificate() {
  return (
    <section
      id="certificates"
      className="flex flex-col py-20 px-5 justify-center bg-primary  shadow-2xl text-white"
    >
      <div className="w-full px-10 py-5">
        <h1 className="text-4xl border-b-4 border-pink-400 w-[250px] font-bold mb-5">
          Achievements
        </h1>
        <p className="text-lg text-pink-100">
          Here are some of my certifications and achievements that highlight my journey through technology, innovation, and learning.
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-10 px-5 md:px-20">
        {certData.map((cert, index) => (
          <motion.div
            key={index}
            className="backdrop-blur-xl bg-white/10 border border-white/20 rounded-2xl shadow-xl p-4"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.2 }}
            custom={index}
            variants={cardVariants}
            whileHover={{
              scale: 1.05,
              boxShadow: "0 0 20px rgba(255, 192, 203, 0.5)",
            }}
            transition={{ type: "spring", stiffness: 100 }}
          >
            <img
              src={cert.img}
              className="h-[250px] w-full object-contain rounded-xl mb-4 border border-white/10"
              alt={`Certificate ${index + 1}`}
            />
            <p className="text-center text-pink-100 text-base">{cert.desc}</p>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
